import React from "react";
import { useProductLikes } from "../../context/StatsContext";
import "./styles.css";

// Begeni kullaniciya gorunur: ♡ 24 / ♥ 25
//
// Kart genelde bir <Link> icinde oldugundan tiklama yayilimi durdurulur;
// aksi halde begenmek urun detayina goturur.
//
// TASINABILIRLIK: Bu dosya butun QR menu projelerine oldugu gibi kopyalanir.
// Projelerin bir kismi ThemeContext kullanmadigi icin tema BU DOSYADAN
// OKUNMAZ; vurgu rengi disaridan prop olarak verilir:
//
//     <LikeButton productId={kod} accentColor={theme.primary} />
//
// Renk verilmezse begenilmis durumun rengi styles.css'teki varsayilandan
// gelir. Boylece tek dosya her projede derlenir.
const LikeButton = ({ productId, size = "sm", accentColor }) => {
  const { likes, liked, toggleLike, enabled } = useProductLikes(productId);

  // Istatistik katmani yoksa (provider disinda) ya da begeni ozelligi
  // kapaliysa butonu hic cizme.
  if (!enabled || !productId) return null;

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    toggleLike?.(productId);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`like-button like-button--${size} ${liked ? "is-liked" : ""}`}
      style={
        liked && accentColor
          ? { color: accentColor, borderColor: accentColor }
          : undefined
      }
      aria-pressed={liked}
      aria-label={liked ? "Beğeniyi geri al" : "Beğen"}
    >
      <span className="like-button-icon">{liked ? "♥" : "♡"}</span>
      <span className="like-button-count">{likes}</span>
    </button>
  );
};

export default LikeButton;
